<template>
  <div class="container">
    <div class="preloader" v-if="preloader">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <div class="main-wrapper">
        <p class="title">работа по замене</p>
        <ReplaceItem 
            v-for="(item, index) in report"
            :itemInfo="item"  
            :index="index"
            :key="index">
        </ReplaceItem>

        <p class="addItem" @click="addItem()"></p>
    </div>
    <p class="sendForm" @click="saveReport()">завершить</p>
  </div>
</template>
<script>
import ReplaceItem from "@/components/replacement/ReplacementItem";
import HeaderTest from "@/components/header/header";
export default {
  components: {ReplaceItem, HeaderTest},
  data: () => ({
    report: [
        {
            comment: '',
            pictureStrBase64: ''
        },
    ],
    preloader: false,
    replaceInProgress: true  //Условие, чтобы запретить переход со страницы пока работа по замене не завершена
  }),
  methods: {
    addItem(){
        let obj = {
          comment: '',
          pictureStrBase64: ''
        }
        this.report.push(obj)
    },
    saveReport(){
        this.preloader = true;
        let data = {
            clientId: this.$route.params.id,
            datePresentation: this.$localStorageGet('ReplacementInfo').replacementDate,
            report: JSON.parse(JSON.stringify(this.report))
        }

        this.$store.dispatch('REPLACEMENT_SAVE_REPORT', data).then(r=>{
          this.sendReport(r.data.hash)
        })
    },
    sendReport(hash){
      this.$store.dispatch('REPLACEMENT_SEND_REPORT', hash).then(r=>{
          if(r.data.status == "success"){
            this.replaceInProgress = false;
            this.preloader = false;
            this.$makeToast(
              "Поздравляем!",
              "success",
              `Отчет успешно сформирован!`
            );
            this.$localStorageDelete('ReplacementInfo')

            setTimeout(()=>{
                this.$router.push({ name: 'mainPage' })
            }, 1500)
          }
            
      })
    }
  },
  mounted(){
    this.replaceInProgress = true;
   
  },
  beforeRouteLeave(to, from, next) {
    // Если не завершили работу по замене, запретить переходить куда-либо
      if(this.replaceInProgress){  
          this.$makeToast('Упс!', 'danger', 'Вы не можете покинуть страницу пока не завершите работу по замене', 50000);
          next(false);
      }else{
          next(true);
      }
  }
};
</script>
<style lang="scss" scoped>
    .title{
        margin-top: 34px;
        text-transform: uppercase;
        font-weight: bold;
        font-size: 24px;
        line-height: 35px;
        margin-bottom: 15px;
    }
    .addItem{
        width: 40px;
        height: 40px;
        background-image: url('../img/addPhoto.svg');
        background-position: center;
        background-size: contain;
        min-height: 40px;
    }
    .sendForm{
        width: 100%;
        height: 50px;
        background: #000;
        margin-top: auto;
        font-size: 18px;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        text-transform: uppercase;
    }
    .main-wrapper{
        max-height: 75vh;
        overflow: auto;
    }
    
</style>